import React from 'react';
import {
  Box,
  Button,
  // Container,
  // Divider,
  Paper,
  Typography,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useHistory, withRouter } from 'react-router'; // import the react-router-dom components
import TranslatedText from '../../components/atoms/translated_text';
import NotificationActions from '../../redux/reducers/notification_reducer/actions';
import useStyles from './styles';
import NotificationsDatatableList from './components/notifications_datatable';
import RemindersDatatableList from './components/reminders_datatable';
import RemindersFilter from './components/reminders_filter';
import NotificationsFilter from './components/notifications_filter';
import clsx from 'clsx';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import { Translations } from './configuration';
import { NotificationTableDefaultFetchValues } from './components/notifications_datatable/configuration';
import { ReminderTableDefaultFetchValues } from './components/reminders_datatable/configuration';
import NavigationConfig from 'navigation/config';
import NotificationViewModal from './components/notifications_datatable/view';
import useQuery from 'custom_hooks/useQuery';
import VatReturnListActions from '../../redux/reducers/vatReturn_list_reducer/actions';
import { parseQueryDate } from '../../utils/dates';

const NotificationPage = (props: any) => {
  // console.log('Render NotificationPage');
  const dispatch = useDispatch();
  const classes = useStyles();
  const query = useQuery();
  const reminderSortField = query.get('sortField')
    ? (query.get('sortField') as string)
    : ReminderTableDefaultFetchValues.TABLE_DEFAULT_SORT_KEY;
  const reminderPage = query.get('page')
    ? Number(query.get('page'))
    : ReminderTableDefaultFetchValues.TABLE_DEFAULT_PAGE;
  const reminderPageSize = query.get('pageSize')
    ? Number(query.get('pageSize'))
    : ReminderTableDefaultFetchValues.TABLE_DEFAULT_PAGE_SIZE;
  const reminderOrder = query.get('order')
    ? (query.get('order') as 'asc' | 'desc')
    : ReminderTableDefaultFetchValues.TABLE_DEFAULT_ORDER;
  const vatNumber = query.get('vatNumber');
  const period = query.get('period');
  const remindedDateFrom = query.get('remindedDateFrom');
  const remindedDateTo = query.get('remindedDateTo');
  const notificationSortField = query.get('notificationSortField')
    ? (query.get('notificationSortField') as string)
    : NotificationTableDefaultFetchValues.TABLE_DEFAULT_SORT_KEY;
  const notificationPage = query.get('notificationPage')
    ? Number(query.get('notificationPage'))
    : NotificationTableDefaultFetchValues.TABLE_DEFAULT_PAGE;
  const notificationPageSize = query.get('notificationPageSize')
    ? Number(query.get('notificationPageSize'))
    : NotificationTableDefaultFetchValues.TABLE_DEFAULT_PAGE_SIZE;
  const notificationOrder = query.get('notificationOrder')
    ? (query.get('notificationOrder') as 'asc' | 'desc')
    : NotificationTableDefaultFetchValues.TABLE_DEFAULT_ORDER;
  const notificationVatNumber = query.get('notificationVatNumber');
  const notificationType = query.get('notificationType');
  const notificationDateFrom = query.get('notificationDateFrom');
  const notificationDateTo = query.get('notificationDateTo');

  React.useEffect(() => {
    dispatch(NotificationActions.fetchUnreadNotificationCountAction());
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(VatReturnListActions.fetchQuartersAction());
    dispatch(VatReturnListActions.fetchMonthQuarters());
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(
      NotificationActions.fetchNotificationListAction({
        sortField: notificationSortField,
        page: notificationPage,
        pageSize: notificationPageSize,
        order: notificationOrder,
        vatNumber: notificationVatNumber,
        notificationType: notificationType,
        notificationDateFrom: notificationDateFrom,
        notificationDateTo: notificationDateTo,
      })
    );
  }, [
    notificationSortField,
    notificationPage,
    notificationPageSize,
    notificationOrder,
    notificationVatNumber,
    notificationType,
    notificationDateFrom,
    notificationDateTo,
    dispatch,
  ]);

  React.useEffect(() => {
    dispatch(
      NotificationActions.fetchReminderListAction({
        sortField: reminderSortField,
        page: reminderPage,
        pageSize: reminderPageSize,
        order: reminderOrder,
        vatNumber: vatNumber,
        period: period,
        remindedDateFrom: remindedDateFrom,
        remindedDateTo: remindedDateTo,
      })
    );
  }, [
    reminderSortField,
    reminderPage,
    reminderPageSize,
    reminderOrder,
    vatNumber,
    period,
    remindedDateFrom,
    remindedDateTo,
    dispatch,
  ]);

  return (
    /*================== Notifications Page ==================*/
    <div>
      {/*================== Notifications Page - Header ==================*/}
      <NotificationViewModal />
      <Paper
        className={clsx(classes.titleLayout)}
        elevation={0}
        variant={'outlined'}
        square
      >
        {/* Notifications Page - Header - Title, Icon & Actions */}
        <Box display="flex" alignItems={'center'}>
          {/* Icon */}
          <NotificationsActiveIcon style={{ marginRight: '.75rem' }} />
          {/* Title */}
          <Typography component={'p'} variant={'h6'}>
            <TranslatedText
              textMap={Translations.page_title}
              defaultText={Translations.page_title.English}
            />
          </Typography>
        </Box>
      </Paper>
      {/*--------------- end of Notifications Page - Header ---------------*/}

      {/*================== Notifications Page - Body ==================*/}
      <div style={{ padding: 12 }}>
        {/*================== Notifications Page - Body - Reminders Section ==================*/}
        <div className={classes.cardLayout}>
          {/* Notifications Page - Body - Reminders Section - Title */}
          <Typography
            component={'p'}
            variant={'h5'}
            style={{ marginBottom: '.5rem' }}
          >
            <TranslatedText
              textMap={Translations.reminders_title}
              defaultText={Translations.reminders_title.English}
            />
          </Typography>

          {/* Notifications Page - Body - Reminders Section - Description */}
          <Typography component={'p'} variant={'subtitle1'}>
            <TranslatedText
              textMap={Translations.reminders_description}
              defaultText={Translations.reminders_description.English}
            />
          </Typography>

          {/* Notifications Page - Body - Reminders Section - Reminders List Table */}
          <div className={classes.tableList}>
            <RemindersFilter
              vatNumber={vatNumber}
              period={period}
              remindedDateFrom={parseQueryDate(remindedDateFrom)}
              remindedDateTo={parseQueryDate(remindedDateTo)}
            />
            <RemindersDatatableList />
          </div>

          {/* Notifications Page - Body - Reminders Section - Buttons & Actions */}
          <Box display="flex" justifyContent="flex-end">
            <div className={classes.dashboardButton}>
              <BackToDashboardPage />
            </div>
          </Box>
        </div>
        {/*--------------- end of Notifications Page - Body - Reminders Section ---------------*/}

        {/*================== Notifications Page - Body - Notifications Section ==================*/}
        <div className={classes.cardLayout}>
          {/* Notifications Page - Body - Notifications Section - Title */}
          <Typography
            component={'p'}
            variant={'h5'}
            style={{ marginBottom: '.5rem' }}
          >
            <TranslatedText
              textMap={Translations.notifications_title}
              defaultText={Translations.notifications_title.English}
            />
          </Typography>

          {/* Notifications Page - Body - Notifications Section - Description */}
          <Typography component={'p'} variant={'subtitle1'}>
            <TranslatedText
              textMap={Translations.notifications_description}
              defaultText={Translations.notifications_description.English}
            />
          </Typography>

          {/* Notifications Page - Body - Notifications Section - Notifications List Table */}
          <div className={classes.tableList}>
            <NotificationsFilter
              vatNumber={notificationVatNumber}
              notificationType={notificationType}
              notificationDateFrom={parseQueryDate(notificationDateFrom)}
              notificationDateTo={parseQueryDate(notificationDateTo)}
            />
            <NotificationsDatatableList />
          </div>

          {/* Notifications Page - Body - Notifications Section - Buttons & Actions */}
          <Box display="flex" justifyContent="flex-end">
            <div className={classes.dashboardButton}>
              <BackToDashboardPage />
            </div>
          </Box>
        </div>
        {/*--------------- end of Notifications Page - Body - Notifications Section ---------------*/}
      </div>
      {/*--------------- end of Notifications Page - Body ---------------*/}
    </div>
    /*--------------- end of Notifications Page ---------------*/
  );
};

const BackToDashboardPage = () => {
  const history = useHistory();
  const goToDashboard = () => {
    history.push(NavigationConfig.dashboardPage().path);
  };

  return (
    <Button
      variant="contained"
      style={{ color: '#e6e6e6', backgroundColor: '#25262d' }}
      onClick={goToDashboard}
    >
      <TranslatedText textMap={Translations.go_to_dashboard} />
    </Button>
  );
};

export default withRouter(NotificationPage);
